module.exports = __webpack_public_path__ + "static/img/four-grade-miner.9401233.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/four-grade-miner.png
// module id = +KV3
// module chunks = 2